import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProjectCreateModalUI from './ProjectCreateModalUI.js'

class ProjectCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      customerId: '',
      projectName: '',
      projectCostF: '',
      expectedMarginPercent: '',
    }
  }

  render() {
    return (
      <ProjectCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        // form fields
        customerId={this.state.customerId}
        onCustomerIdChange={(event) => { this.setState({ customerId: event.target.value }) }}
        customerIdError={this.state.customerIdError}
        setCustomerIdError={(error) => { this.setState({ customerIdError: error }) }}
        customerList={this.props.customerList}
        //
        projectName={this.state.projectName}
        onProjectNameChange={(event) => { this.setState({ projectName: event.target.value }) }}
        projectNameError={this.state.projectNameError}
        setProjectNameError={(error) => { this.setState({ projectNameError: error }) }}
        //
        projectCostF={this.state.projectCostF}
        onProjectCostChange={(event) => { this.setState({ projectCostF: event.target.value }) }}
        projectCostError={this.state.projectCostError}
        setProjectCostError={(error) => { this.setState({ projectCostError: error }) }}
        //
        expectedMarginPercent={this.state.expectedMarginPercent}
        onExpectedMarginPercentChange={(event) => { this.setState({ expectedMarginPercent: event.target.value }) }}
        expectedMarginPercentError={this.state.expectedMarginPercentError}
        setExpectedMarginPercentError={(error) => { this.setState({ expectedMarginPercentError: error }) }}
      />
    )
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      projectNameError: null,
      projectCostError: null,
      expectedMarginPercentError: null
    })
    this.props.onCancelCreate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.setState({
      // loanTypeList: loanTypeList,
      // appFlavorList: appFlavorList, loanPurposeList: loanPurposeList
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/customers/${this.state.customerId}/projects`,
      this.onSubmitCallback, {
      projectName: this.state.projectName,
      projectCostF: this.state.projectCostF,
      expectedMarginPercent: this.state.expectedMarginPercent
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default ProjectCreateModalSF
